export const CONSENT_KEY = "tat_privacy_choice";
export const CONSENT_VERSION = 3;
export const CONSENT_MAX_AGE = 180 * 24 * 60 * 60 * 1000;

export interface PrivacyPreferences { analytics: boolean; replay: boolean; }
export interface PrivacyChoice extends PrivacyPreferences { version: number; savedAt: number; }
export const NO_OPTIONAL_TRACKING: Readonly<PrivacyPreferences> = { analytics: false, replay: false };

export function createPrivacyChoice(preferences: PrivacyPreferences, now = Date.now()): PrivacyChoice {
  return { version: CONSENT_VERSION, savedAt: now, analytics: preferences.analytics, replay: preferences.analytics && preferences.replay };
}

export function parsePrivacyChoice(value: string | null, now = Date.now()): PrivacyChoice | null {
  if (!value) return null;
  try {
    const choice = JSON.parse(value) as Partial<PrivacyChoice> | null;
    if (!choice || choice.version !== CONSENT_VERSION || typeof choice.savedAt !== "number"
      || !Number.isFinite(choice.savedAt) || choice.savedAt > now || now - choice.savedAt >= CONSENT_MAX_AGE
      || typeof choice.analytics !== "boolean" || typeof choice.replay !== "boolean") return null;
    return createPrivacyChoice(choice as PrivacyChoice, choice.savedAt);
  } catch { return null; }
}
